module.exports = __webpack_public_path__ + "img/HumaneWorld-H-RGB-Blue-Black.7de36e85.png";